
import LangSelect from '@/components/Lang.vue';
import { throttle } from '@/utils/util_function';
import { Component, Vue } from 'vue-property-decorator'
@Component({
  components: {
    LangSelect
  }
})
export default class extends Vue {
  hasWhiteBg = false;
  throttle = throttle(this.handleScroll, 50);

  mounted() {
    window.addEventListener("scroll", this.throttle);
  }

  destroyed() {
    window.removeEventListener('scroll', this.throttle);
  }

  handleScroll() {
    const winWidth = window.innerWidth;
    const headerImgRef: any = this.$refs.headerImg;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
    let difValue = headerImgRef.offsetHeight;
    if (winWidth > 750) {
      difValue -= 120; 
    }
    if(scrollTop > difValue){
      this.hasWhiteBg = true;
    }else{
      this.hasWhiteBg = false;
    }
  }
}
